import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

import * as service from "../services/roleService";
import * as utils from "../utils/utilities";

const slice = createSlice({
  name: "roles",
  initialState: {
    loading: false,
    error: false,
    lastUpdated: null,
    roles: [],
  },
  reducers: {
    rolesRequested: (state, action) => {
      state.loading = true;
    },
    rolesRequestSuccess: (state, action) => {
      state.roles = action.payload;
      state.loading = false;
      state.error = false;
    },
    rolesRequestFailed: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    updateSyncTime: (state, action) => {
      state.lastUpdated = Date.now();
    },
  },
});

export const loadRoles = () => async (dispatch, getState) => {
  try {
    dispatch(slice.actions.rolesRequested());

    const result = await service.getAllRoles();
    const roles = result.data.map(utils.transformRoleItem);

    dispatch(slice.actions.rolesRequestSuccess(roles));
    dispatch(slice.actions.updateSyncTime());
  } catch (ex) {
    const cachedData = utils.getCachedDataFromException(ex);
    if (!cachedData) return dispatch(slice.actions.rolesRequestFailed());

    const roles = cachedData.map(utils.transformRoleItem);
    dispatch(slice.actions.rolesRequestSuccess(roles));
  }
};

export const getRoles = createSelector(
  (state) => state,
  (state) => state.roles
);

export default slice.reducer;
